<template>
    <section class="modal-mask superadmin-modal superadmin-modal-import">
        <div class="modal-wrapper">
            <div class="modal-container" v-click-outside="closeOpenModal">
                <div class="modal-body">
                    <h2>{{ title }}</h2>

                    <div class="label">
                        <span>{{ label }}</span>
                        <InfoIconWithLabel :labelInfo="labelInfo"/>
                    </div>

                    <div class="input-file-box">
                        <input type="file" id="import-file" @change="checkIfFileSelected"/>
                    </div>
                </div>
                <div class="modal-footer">
                    <CustomButton buttonType="upload" buttonText="Import" :callback="returnImportFile" :isDisabled="!hasFileSelected"/>

                    <CustomButton buttonType="close" :callback="closeOpenModal"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CustomButton from "./CustomButton";
    import InfoIconWithLabel from "./InfoIconWithLabel";

    export default {
        name: "SuperAdminCustomForm",
        components: {InfoIconWithLabel, CustomButton },
        props: ["title", "label", "labelInfo"],
        data() {
            return {
                hasFileSelected: false,
                showLabelInfo: false,
                tooltipText: '<i class="material-icons">close</i>'
            }
        },
        methods: {
            checkIfFileSelected(evt) {
                this.hasFileSelected = evt.target.files.length > 0;
            },

            async hideLabel() {
                await this.timeout(500);
                this.showLabelInfo = false;
            },

            returnImportFile() {
                const file = document.getElementById("import-file").files[0];

                this.$store.dispatch('triggerModalCallback', file);
            },
        }
    }
</script>

<style lang="scss">
    .superadmin-modal-import {
        @include input-file-box;

        .label {
            display: flex;
            align-items: center;
            padding: 0 0 12px;

            text-align: left;
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
            color: $black-1;

            i {
                cursor: pointer;
            }

            span {
                margin-right: 4px;
            }
        }

        .modal-container .modal-footer {
            margin-top: 24px;
        }

        .button-container {
            margin-right: 16px;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }
</style>